import Vue from 'vue';
import { Component, Inject } from 'vue-property-decorator';
import CcUser from '@/main/webapp/resources/src/vue/domain/user/cc-user';
import { CC_CONTAINER_TYPES } from '@/main/webapp/resources/src/vue/infrastructure/ioc/cc-container-types';
import CcCcServiceInterface from '@/main/webapp/resources/src/vue/service/cc-service-interface';
import { Utils } from '@/main/webapp/resources/src/vue/infrastructure/utils/helpers';
import CcProperty from '@/main/webapp/resources/src/vue/domain/user/cc-property';
const CcAccountIconComponent = () => import(/* webpackChunkName: 'cc-account-icon' */ '@/main/webapp/resources/src/vue/components/cc-account-icon/cc-account-icon.vue');

@Component({
	components: {
		CcAccountIcon: CcAccountIconComponent
	}
})
export default class CcApplicationNavigationMenuComponent extends Vue {
	@Inject(CC_CONTAINER_TYPES.CcServiceInterface)
	private service!: CcCcServiceInterface;

	get user (): CcUser {
		return this.$store.getters.user ? this.$store.getters.user : '';
	}

	get userLogged (): boolean {
		return this.$store.getters.user ? this.$store.getters.user.logged : false;
	}

	get hasChangePasswordUrl () {
		return !!Utils.getChangePasswordUrl();
	}

	get getChangePasswordUrl () {
		const property: CcProperty = this.user ? this.user.properties.find((property: CcProperty) => property.code === 'authorizationCode') : null;
		return property ? `${Utils.getChangePasswordUrl()}?code=${property.values[0]}` : Utils.getChangePasswordUrl();
	}

	get isCustomAddressEnabled () {
		return Utils.isCustomAddressEnabled();
	}

	get getOpenUrlTarget () {
		return '_blank'; // Utils.getOpenUrlTarget();
	}

	private toggleApplicationNavigationMenu () {
		this.$root.$emit('toggle-application-navigation-menu');
	}

	private logout () {
		this.$root.$emit('logout');
	}
}
